import { render, staticRenderFns } from "./EditWebHook.vue?vue&type=template&id=4dc2820a&"
import script from "./EditWebHook.vue?vue&type=script&lang=js&"
export * from "./EditWebHook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports